





















































































































import Vue from 'vue'
import {
  MasterlinkTenantServiceProxy,
  Tenant
} from '@/service-proxies/app-v2/system.service-proxies'
import { isCellphoneNo } from '@/utils/validate'
const TenantService = new MasterlinkTenantServiceProxy()

export default Vue.extend({
  data() {
    return {
      form: this.$form.createForm(this)
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    tenantClasses: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    validatePhone(rule: any, value: any, callback: any) {
      if (!isCellphoneNo(value)) {
        callback(this.$t('page_tenant_input_the_correct_mobile_number'))
      }
      callback()
    },
    onClose() {
      this.$emit('closemodal', false)
      this.form.resetFields();
    },
    onSave() {
      this.form.validateFields((err: any, values: any) => {
        if (!err) {
          values.id = this.formData.id

          // 户主
          values.classes = this.formData.classes === 1 ? 1 : values.classes

          TenantService.updateTenant(values).then(res => {
            this.$message.success(this.$t('page_tenant_have_been_saved'))
            this.$emit('closemodal', true)
            this.form.resetFields()
          })
        }
      })
    }
  }
})
